import { CellRenderer, MainColumns } from '../../../../../../components/TableGrid';

export interface TableData {
  columns: MainColumns[];
  rows?: any[];
}

interface TransformDynamicMatrixData {
  data?: any[];
  translation?: Map<string, string> | { [key: string]: string };
}

export function transformMatrixData({
  data = [],
  translation,
}: TransformDynamicMatrixData): TableData {
  const columns: MainColumns[] = [
    {
      headerName: '',
      field: 'name',
      cellClass: 'borderedRight',
      minWidth: 320,
      pinned: 'left',
      suppressColumnsToolPanel: true,
    },
  ];
  const rowsMap: Map<string, any> = new Map();

  data.forEach((item: any) => {
    columns.push({
      headerName: String(item.year),
      field: String(item.year),
      cellRenderer: CellRenderer.LinkOrNumberOrText,
      minWidth: 100,
      flex: 1,
    });

    const translationMap = new Map(Object.entries(translation as object));
    const lines = new Map(Object.entries(item.financialLines));
    Array.from(lines.keys()).forEach((rowName) => {
      if (!rowsMap.has(rowName)) {
        rowsMap.set(rowName, {
          name:
            translationMap && translationMap.has(rowName) ? translationMap?.get(rowName) : rowName,
        });
      }

      rowsMap.get(rowName)[String(item.year)] = lines.get(rowName);
    });
  });

  const rows = Array.from(rowsMap.values());
  columns.reverse();

  return { columns, rows };
}
